import { createAsyncThunk } from "@reduxjs/toolkit";
import DisbursementsAPI, {
    GetDisbursementsResponse,
    UpsertDisbursementsParams,
} from "../../../api/disbursements";
import { MessageResponse } from "../../../api/physicalTechnicalVerifications";
import { RootState } from "../../../app/store";


export const fetchDisbursements = createAsyncThunk<
    GetDisbursementsResponse,
    string,
    { state: RootState; rejectValue: string }
>(
    "disbursements/fetchDisbursements",
    async (caseId, { rejectWithValue }) => {
      try {
        return await DisbursementsAPI.getDisbursements({ case_id: caseId });
      } catch {
        return rejectWithValue("Failed to fetch disbursements");
      }
    },
    {
      condition(caseId, { getState }) {
        const state = getState().disbursements;

        return !(
          state.caseId === caseId &&
          (state.status === "loading" || state.status === "success")
        );
      },
    },
);

export const upsertDisbursements = createAsyncThunk<
    MessageResponse,
    UpsertDisbursementsParams,
    { rejectValue: string }
>(
    "disbursements/upsertDisbursements",
    async (params, { rejectWithValue }) => {
      try {
        return await DisbursementsAPI.upsertDisbursements(params);
      } catch {
        return rejectWithValue("Failed to save disbursements");
      }
    },
);
